<template>
	<!-- 个人中心--个人首页 -->
	<div id="grsy">
		<div class="grsy_info_box">
			<ul>
				<li>
					<div class="user_head">
						<img :src="`${url}/MugShot/${userInfo.MugShot}`" alt="" @click="changeHead" />
						<div style="line-height: 30px; margin-left: 10px">
							<p style="font-size: 16px">{{ userInfo.LoginName }}</p>
							<p style="font-size: 12px; color: #ccc">[上次登录IP：{{ $store.state.userInfo.LastLoginIp }}]</p>
						</div>
					</div>
				</li>
				<li>
					<div class="money_box">
						<div class="balance">
							<p>
								余额：<span style="color: red; margin-right: 10px">￥{{ userInfo.Balance }}</span>
							</p>
							<span :class="`iconfont icon-shuaxin ${Refresh ? 'refresh_anima' : ''}`" @click="refresh"></span>
						</div>
						<div class="cz_btn_box">
							<el-button type="primary" @click="toCenter" data-name="zhcz" data-value="zhcz">充值</el-button>
							<el-button @click="toCenter" data-name="yetx" data-value="yetx">提款</el-button>
						</div>
					</div>
				</li>
				<li style="padding-top: 30px; padding-left: 40px">
					<div class="security">
						<div style="display: flex; align-items: center">
							<img style="margin-right: 10px" src="../../static/img/userComs/security.png" alt="" />
							<span>账户安全等级：中</span>
						</div>
					</div>
					<div class="rate_box">
						<el-rate
							v-model="value1"
							:colors="['#FFC445', '#FFC445', '#FFC445']"
							:void-color="'#FFC445'"
							:disabled-void-color="'#FFC445'"
						/>
					</div>
					<p style="color: #ccc">安全等级，等级越高，您的账号和资金越安全。</p>
				</li>
			</ul>
		</div>
		<div class="bot_btn_box">
			<p>完善一下资料可以增加安全等级，等级越高，您的账号和资金越安全。</p>
			<div class="username_cz_box">
				<ul>
					<li @click="changesBtnGRSY(1)">
						<img src="../../static/img/userComs/password.png" alt="" />
						<p>登录密码</p>
						<p class="text_introduce">建议使用数字加密码</p>
					</li>
					<li @click="changesBtnGRSY(2)">
						<img src="../../static/img/userComs/tq.png" alt="" />
						<p>提现密码</p>
						<p class="text_introduce">银行卡绑定，转账等资金需密码确认，请尽快修改</p>
					</li>
					<li @click="changesBtnGRSY(3)">
						<img src="../../static/img/userComs/aq.png" alt="" />
						<p>设置安全问题</p>
						<p class="text_introduce">如果账号已设置安全问题，不能二次修改。</p>
					</li>
					<li @click="changesBtnGRSY(4)">
						<img src="../../static/img/userComs/mobilephone.png" alt="" />
						<p>手机绑定</p>
						<p class="text_introduce">绑定手机号之后，异地登录提醒</p>
					</li>
					<li @click="changesBtnGRSY(4)">
						<img src="../../static/img/userComs/mailbox.png" alt="" />
						<p>邮箱设置</p>
						<p class="text_introduce">用于账户异地登录验证，增加您的账户安全性。</p>
					</li>
				</ul>
			</div>
		</div>
		<!-- 修改頭像弹窗 -->
		<el-dialog title="选择大头照" :visible.sync="headDialog" width="531px" :show-close="false">
			<div class="close_login" @click="headDialog = false">
				<span></span>
			</div>
			<div class="head__zone">
				<span :class="index == chooiseHead ? 'check' : 'uncheck'" v-for="(item, index) in headImgList" :key="index"
					><img :src="`${url}${item.url}`" alt="" @click="needHead(item.val - 1)"
				/></span>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="pop_sure_btn" type="primary" @click="headSure">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 修改登录密码弹窗 -->
		<el-dialog
			title="登录密码"
			:visible.sync="withdrawalDialog"
			width="531px"
			:before-close="handleClose(2)"
			:show-close="false"
		>
			<div class="close_login" @click="closeDialog(1)">
				<span></span>
			</div>
			<p class="green">为了保障您的资金安全，修改后请牢记您的密码！</p>
			<div class="demo-input-suffix">
				<span class="text_style">旧密码：</span>
				<el-input type="password" v-model="oldPassword" placeholder="请输入旧密码" />
			</div>
			<div class="demo-input-suffix">
				<span class="text_style">新密码：</span>
				<el-input type="password" @input="checkPassword" v-model="newPassword" placeholder="请输入新密码8位数以上" />
			</div>
			<div v-if="!isPasswordValid" class="passwordValid">
				<!-- 密碼不符合規則： -->
				<ul>
					<li v-if="!hasDifferentFromUsername">* 为确保您的资金安全，密码请勿与账号相同。</li>
					<li v-if="!isLengthValid">* 密码長度應為 8-20 位。</li>
					<li v-if="!hasSpecialChar">* 为确保您的资金安全，密码须包含至少一种 @$!%*?&.+-/\ 特殊符号。</li>
					<li v-if="!hasRequiredCharacters">* 为确保您的资金安全，密码须包含使用英文字母大小写、数字中两种。</li>
				</ul>
			</div>
			<!-- <p class="green" style="margin: 2px 0">请输入8-20个字母加数字，特殊符合组合的密码</p> -->
			<div class="demo-input-suffix">
				<span class="text_style">确认密码：</span>
				<el-input type="password" v-model="surePassword" placeholder="请确认密码8位数以上" />
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="pop_sure_btn" type="primary" @click="passwordSure">确 定</el-button>
				<el-button class="cancel_btn" type="primary" @click="withdrawalDialog = false">取 消</el-button>
			</span>
		</el-dialog>

		<!-- 修改提现密码弹窗 -->
		<el-dialog title="提现密码" :visible.sync="passwordDialog" :before-close="handleClose(1)" :show-close="false">
			<div class="close_login" @click="passwordDialog = false">
				<span></span>
			</div>
			<div class="demo-input-suffix">
				<span class="text_style">旧密码：</span>
				<el-input type="password" v-model="withdrawal.oldPassword" placeholder="请输入旧密码" />
			</div>
			<div class="demo-input-suffix">
				<span class="text_style">新密码：</span>
				<el-input type="password" v-model="withdrawal.newPassword" placeholder="请输入新密码" />
			</div>
			<div class="demo-input-suffix">
				<span class="text_style">确认密码：</span>
				<el-input type="password" v-model="withdrawal.surePassword" placeholder="请确认密码" />
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="pop_sure_btn" type="primary" @click="withdrawalSure">确 定</el-button>
				<el-button class="cancel_btn" type="primary" @click="passwordDialog = false">取 消</el-button>
			</span>
		</el-dialog>

		<!-- 安全问题 -->
		<el-dialog title="修改安全问题" :visible.sync="questionDialog" :before-close="handleClose(3)" :show-close="false">
			<div class="close_login" @click="closeDialog(3)">
				<span></span>
			</div>
			<div class="row_style">
				<div class="row_text_style">问题：</div>
				<el-select v-model="questform.currQuestion" placeholder="请选择安全问题">
					<el-option v-for="item in questionArr" :key="item.SqId" :label="item.Question" :value="item.SqId" />
				</el-select>
			</div>
			<div class="row_style">
				<div class="row_text_style">答案：</div>
				<div>
					<el-input v-model="questform.answer"></el-input>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="pop_sure_btn" type="primary" @click="questionSure">确 定</el-button>
				<el-button class="cancel_btn" type="primary" @click="questionDialog = false">取 消</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
// 引用axios封装文件
import { postAjax, getAjax } from "../../util/ajax.js";
import { SysKey } from "@/util/sysconfig";
export default {
	name: "grsy",
	data() {
		return {
			value1: 3,
			activeNames: 0,
			Refresh: false,
			//修改提现密码弹窗
			passwordDialog: false,
			//登录密码弹窗
			withdrawalDialog: false,
			//頭像彈窗
			headDialog: false,
			//安全问题弹窗
			questionDialog: false,
			//个人信息
			userInfo: {
				LoginName: "", //登录名
				Balance: "", //余额
				UtId: "",
				FullName: "",
				NickName: "",
				QqNumber: "",
				Email: "",
				PhoneNumber: "",
				LastLoginTime: "",
				SupQqNumber: "",
				SupPhoneNumber: "",
				IsDataLock: false,
				UserRebate: "",
				UtName: "",
				CreateTime: "",
				IsOnline: "",
				SupName: "",
				LoginCount: "",
			},
			questionArr: [],
			//questform
			questform: {
				//当前问题
				currQuestion: "",
				answer: "",
			},

			//旧密码
			oldPassword: "",
			//新密码
			newPassword: "",
			//确认新密码
			surePassword: "",
			//提现密码
			withdrawal: {
				oldPassword: "",
				newPassword: "",
				surePassword: "",
			},
			//安全等级数组
			safeLev: [1, 1, 1, 0, 0],

			//提示弹窗
			tipsPop: false,
			tipsInfo: "",
			isPasswordValid: true,
			hasDifferentFromUsername: true,
			hasSpecialChar: true,
			isLengthValid: true,
			hasRequiredCharacters: true,
			url: SysKey("ImgServerUrl").SysValue, //图片地址
			headImgList: [
				{ url: "/MugShot/1.png", val: 1 },
				{ url: "/MugShot/2.png", val: 2 },
				{ url: "/MugShot/3.png", val: 3 },
				{ url: "/MugShot/4.png", val: 4 },
				{ url: "/MugShot/5.png", val: 5 },
				{ url: "/MugShot/6.png", val: 6 },
				{ url: "/MugShot/7.png", val: 7 },
				{ url: "/MugShot/8.png", val: 8 },
				{ url: "/MugShot/9.png", val: 9 },
				{ url: "/MugShot/10.png", val: 10 },
				{ url: "/MugShot/11.png", val: 11 },
				{ url: "/MugShot/12.png", val: 12 },
				{ url: "/MugShot/13.png", val: 13 },
				{ url: "/MugShot/14.png", val: 14 },
				{ url: "/MugShot/15.png", val: 15 },
				{ url: "/MugShot/16.png", val: 16 },
			],
			chooiseHead: null,
		};
	},
	computed: {
		showPhone() {
			return this.userInfo.PhoneNumber ? this.userInfo.PhoneNumber : "未绑定";
		},
		showMail() {
			return this.userInfo.Email ? this.userInfo.Email : "未设置";
		},
	},
	methods: {
		headSure() {
			let that = this;
			let data = {
				MugShot: this.chooiseHead + 1,
				QqNumber: this.userInfo.QqNumber,
				PhoneNumber: this.userInfo.PhoneNumber,
			};
			let url = "Api/User/UserUpdateInfo";
			postAjax(url, data)
				.then(function (data) {
					if (data.IsSucess) {
						that.getUserInfo();
						that.$message({
							message: "修改成功",
							type: "success",
						});
					} else {
						that.$message.error(data.Message);
					}
				})
				.catch(() => {});
			this.headDialog = false;
		},
		needHead(val) {
			this.chooiseHead = val;
		},
		changeHead() {
			if (!this.userInfo.QqNumber) {
				this.$message.error("请先绑定QQ号");
				this.$router.push("/UserCenter?name=grzl&value=grzl");
			} else {
				this.headDialog = true;
			}
		},
		handleHeadDialog() {
			this.headDialog = false;
		},
		checkPassword() {
			const username = this.userInfo.LoginName;
			const lowercaseRegex = /^(?=.*[a-z])/;
			const uppercaseRegex = /^(?=.*[A-Z])/;
			const digitRegex = /^(?=.*\d)/;
			const specialCharRegex = /^(?=.*[@$!%*?&.\-+/\\])/;

			const lowercaseMatch = lowercaseRegex.test(this.newPassword);
			const uppercaseMatch = uppercaseRegex.test(this.newPassword);
			const digitMatch = digitRegex.test(this.newPassword);
			const specialCharMatch = specialCharRegex.test(this.newPassword);
			this.hasRequiredCharacters = [lowercaseMatch, uppercaseMatch, digitMatch].filter(Boolean).length >= 2;
			this.hasSpecialChar = specialCharMatch;
			this.hasDifferentFromUsername = this.newPassword !== username;
			this.isLengthValid = this.newPassword.length >= 8 && this.newPassword.length <= 20;
			this.isPasswordValid =
				this.hasRequiredCharacters && this.hasSpecialChar && this.hasDifferentFromUsername && this.isLengthValid;
		},
		// 关闭弹窗
		closeDialog(type) {
			switch (type) {
				case 1:
					this.withdrawalDialog = false; // 登录密码
					break;
				case 2:
					this.passwordDialog = false; // 提现密码
					break;
				case 3:
					this.questionDialog = false; // 安全问题
					break;
			}
		},
		// 充值 提现
		toCenter(e) {
			let name = e.target.dataset.name;
			let value = e.target.dataset.value;
			this.$router.push({
				name: "UserCenter",
				query: {
					name: name,
					value: value,
				},
			});
		},
		closeThisWindow() {
			this.activeNames = 0;
		},
		// 刷新
		refresh() {
			let that = this;
			if (this.Refresh == false) {
				that.Refresh = true;
				that.$store.dispatch("getUserInfo");
				that.getUserInfo();
				setTimeout(function () {
					that.Refresh = false;
				}, 1500);
			}
		},
		//密码确认按钮
		passwordSure() {
			if (this.isPasswordValid == false) {
				this.$message.error("新密码请输入正确格式");
				return;
			}
			if (this.newPassword == this.oldPassword) {
				this.$message.error("新密码不能和旧密码一致");
				return;
			}
			if (this.oldPassword && this.newPassword && this.surePassword) {
				if (this.newPassword != this.surePassword) {
					this.$message.error("两次密码不一致");
				} else {
					if (this.newPassword.length >= 8) {
						let that = this;
						let url = "api/User/UserUpdatePwdInfo";
						let data = {
							PwdType: "0",
							oldPassword: this.oldPassword,
							newPassword: this.newPassword,
							confirmPassword: this.surePassword,
						};
						postAjax(url, data).then(function (data) {
							if (data.IsSucess) {
								that.$message({
									message: "密码修改成功",
									type: "success",
								});
								that.withdrawalDialog = false;
								that.activeNames = 0;
							} else {
								that.$message.error(data.Message);
							}
						});
					} else {
						this.$message.error("请输入最少八位数字密码");
					}
				}
			} else {
				this.$message.error("必填项不能为空");
			}
		},
		//提现密码确认
		withdrawalSure() {
			if (this.withdrawal.oldPassword && this.withdrawal.newPassword && this.withdrawal.surePassword) {
				if (this.withdrawal.newPassword != this.withdrawal.surePassword) {
					this.$message.error("两次密码不一致");
				} else {
					if (this.withdrawal.newPassword.length >= 6) {
						let that = this;
						let url = "api/User/UserUpdatePwdInfo";
						let data = {
							PwdType: "1",
							oldPassword: this.withdrawal.oldPassword,
							newPassword: this.withdrawal.newPassword,
							confirmPassword: this.withdrawal.surePassword,
						};
						postAjax(url, data).then(function (data) {
							if (data.IsSucess) {
								that.$message({
									message: "密码修改成功",
									type: "success",
								});
								that.withdrawalDialog = false;
								that.activeNames = 0;
							} else {
								that.$message.error(data.Message);
							}
						});
					} else {
						this.$message.error("请输入最少六位数字密码");
					}
				}
			} else {
				this.$message.error("必填项不能为空");
			}
		},
		//安全问题确认
		questionSure() {
			if (this.questform.answer && this.questform.currQuestion) {
				let that = this;
				let url = "api/User/SetSecurityQuestion";
				let data = {
					Answer: this.questform.answer,
					SqId: this.questform.currQuestion,
				};
				postAjax(url, data).then(function (data) {
					if (data.IsSucess) {
						that.$message({
							message: "设置成功",
							type: "success",
						});
						that.userInfo.IsDataLock = true;
						that.questionDialog = false;
						that.activeNames = 0;
					} else {
						that.$message.error(data.Message);
					}
				});
			} else {
				this.$message.error("必填项不能为空");
			}
		},
		//得到安全问题
		getQuestion() {
			let that = this;
			let url = "api/User/GetSecurityQuestion";
			postAjax(url, null).then(function (data) {
				if (data.IsSucess) {
					that.questionArr = data.Data;
				}
			});
		},
		changesBtnGRSY(type) {
			switch (type) {
				case 1:
					this.withdrawalDialog = true;
					break;
				case 2:
					this.passwordDialog = true;
					this.getQuestion();
					break;
				case 3:
					this.questionDialog = true;
					break;
				case 4:
					this.$emit("routerChange", "grzl");
					break;
			}
		},
		// 得到用户信息方法
		getUserInfo() {
			let that = this;
			let url = "Api/User/GetUserInfo";
			postAjax(url, null)
				.then(data => {
					if (data.IsSucess) {
						that.userInfo = data.Data;
					} else {
						that.userInfo = [];
					}
				})
				.catch(() => {
					that.userInfo = [];
				});
		},
		handleClose(num) {},
	},
	mounted() {
		this.getUserInfo();
		this.getQuestion();
	},
};
</script>
<style lang="scss">
#grsy .el-collapse {
	border: none;
}

#grsy .el-collapse .el-collapse-item {
	margin-bottom: 20px;
	background-color: #f7f7f7;
	border-radius: 5px;
	border: solid 1px #dddddd;
}

#grsy .grsy_item {
	display: flex;
	align-items: center;
	position: relative;
	width: 100%;
	height: 47px;
	margin-bottom: 20px;
	border: solid 1px #d9d9d9;
	background-image: linear-gradient(0deg, #eaeaea 0%, #f1f1f1 100%);
	border-radius: 5px;
	padding: 0 11px;
	cursor: pointer;
}

#grsy .el-collapse .el-collapse-item .el-collapse-item__header {
	position: relative;
	width: 100%;
	height: 47px;
	background-image: linear-gradient(0deg, #eaeaea 0%, #f1f1f1 100%);
	border-radius: 5px;
	border: none;
	padding: 0 11px;
}

#grsy .el-collapse .el-collapse-item .el-collapse-item__wrap {
	background-color: #f7f7f7;
	border: none;
}

#grsy .el-collapse-item__header b,
#grsy .grsy_item b {
	font-size: 14px;
}

#grsy .el-collapse-item__header span,
#grsy .grsy_item span {
	margin-left: 15px;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0;
	color: #9d9d9c;
}

#grsy .el-collapse-item__header .close,
#grsy .grsy_item .close {
	position: absolute;
	right: 37px;
	color: #d86556;
}

#grsy .el-collapse-item__header .unclose,
#grsy .grsy_item .unclose {
	position: absolute;
	right: 20px;
	color: #333333;
}

.unclose:hover {
	color: #d86556 !important;
}

.unclose:hover span {
	color: #d86556 !important;
}

.unclose > span {
	margin-left: 5px !important;
}

#grsy .dialog-footer {
	display: flex;
	justify-content: center;
}

.el-button + .el-button {
	margin-left: 18px;
}

#grsy .el-icon-arrow-right {
	display: none;
}

#grsy .rate_box {
	width: 176px;
	height: 36px;
	background: linear-gradient(-90deg, #ffe4ce, #fff0e3, #fcfaf8);
	border-radius: 20px 20px 20px 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 8px;

	.el-rate {
		height: auto;
		pointer-events: none;

		.el-rate__icon {
			font-size: 24px;
		}
	}
}
</style>
<style lang="scss" scoped>
.grsy_info_box {
	width: 100%;
	height: 160px;
	border-bottom: 1px solid #e4e4e4;
}

.grsy_info_box > ul {
	width: 100%;
	height: 100%;
	display: flex;
}

.grsy_info_box > ul > li {
	width: 30%;
	height: 100%;
	position: relative;
}

.grsy_info_box > ul > li:nth-child(1)::before {
	content: "";
	position: absolute;
	right: 0;
	top: 20px;
	width: 1px;
	height: 110px;
	background-color: #e4e4e4;
}

.grsy_info_box > ul > li:nth-child(2)::before {
	content: "";
	position: absolute;
	right: 0;
	top: 20px;
	width: 1px;
	height: 110px;
	background-color: #e4e4e4;
}

.user_head {
	height: 100%;
	display: flex;
	justify-content: flex-start;
	align-items: center;
	padding-left: 30px;
}

.user_head > img {
	width: 70px;
	height: 70px;
	cursor: pointer;
}

.money_box {
	width: 100%;
	height: 100%;
	padding: 40px 0 0;

	.balance {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0 auto;
		font-size: 18px;
		color: #999;

		.iconfont {
			font-size: 18px;
			color: #666666;
		}
	}
}

.cz_btn_box {
	display: flex;
	justify-content: center;
	margin: 15px auto 0;

	.el-button {
		margin: 0 8px;
		padding: 9px 19px;
		font-size: 16px;

		&.el-button--default {
			border: 1px solid #705aff;
			color: #705aff;
		}
	}
}

.security {
	margin-bottom: 15px;
	font-size: 14px;
	img {
		width: 20px;
		height: 20px;
	}
}

.bot_btn_box {
	width: 100%;
	height: 300px;
	padding-top: 15px;
}

.bot_btn_box > p {
	color: #666666;
	font-size: 14px;
}

.username_cz_box {
	width: 100%;
	margin-top: 20px;
}

.username_cz_box > ul {
	width: 100%;
}

.username_cz_box > ul > li {
	width: 160px;
	height: 160px;
	background-color: #f7f7f7;
	float: left;
	margin: 0px 15px;
	border-radius: 10px 10px 10px 10px;
	text-align: center;
	word-break: break-all;
	cursor: pointer;
	padding: 20px 8px 0;
}

.username_cz_box > ul > li > img {
	margin-bottom: 6px;
	width: 44px;
	height: 44px;
}

.username_cz_box > ul > li > p {
	margin-bottom: 6px;
	font-size: 14px;
	color: #666;
}

.username_cz_box > ul > li > p.text_introduce {
	font-size: 12px;
	color: #999;
}

#grsy {
	width: 100%;
	height: 100%;

	.person_info {
		display: flex;
		justify-content: center;
		width: 100%;
		height: 140px;
		border-bottom: solid 1px #d8d8d8;

		.left_money {
			position: relative;
			width: 50%;
			height: 100%;
			line-height: 140px;
			font-size: 20px;
			font-weight: normal;
			font-stretch: normal;
			letter-spacing: 0;
			color: #707070;
			text-indent: 21px;

			strong {
				font-size: 36px;
				font-weight: normal;
				font-stretch: normal;
				line-height: 16px;
				letter-spacing: 0;
				color: #d86556;
			}

			span {
				display: inline-block;
				font-size: 40px;
				margin-left: 40px;
				cursor: pointer;
				text-indent: 0;
				color: #c8c8c8;

				&:hover {
					color: #9c9c9c;
				}
			}

			&:after {
				content: "";
				position: absolute;
				top: 21px;
				right: 0;
				width: 2px;
				height: 97px;
				background-color: #d8d8d8;
			}
		}

		.right_safety {
			width: 50%;
			padding: 34px 0 0 47px;

			.safe_lev {
				display: flex;
				justify-content: start;
				align-items: center;

				.star {
					color: #d0d0d0;
					margin-right: 8px;
					font-size: 40px;
				}

				.star_active {
					color: #ff690b;
					font-size: 40px;
					margin-right: 8px;
				}
			}

			& p {
				font-size: 14px;
				font-weight: normal;
				font-stretch: normal;
				letter-spacing: 0;
				color: #171717;
			}
		}
	}

	.bottom_box {
		width: 100%;
		height: 780px;
		padding: 28px 20px 0;
		overflow: auto;

		& > p {
			font-size: 14px;
			font-weight: normal;
			font-stretch: normal;
			line-height: 14px;
			letter-spacing: 0;
			color: #707070;
			margin-bottom: 16px;
		}
	}
}

/*公*/
#grsy .el-col {
	text-align: center;
}

#grsy .user_image {
	width: 80px;
	height: 80px;
	border-radius: 100px;
	margin-top: 40px;
}

#grsy .name {
	font-size: 16px;
	font-weight: bold;
	color: black;
	line-height: 24px;
	margin-top: 50px;
}

#grsy .yue {
	font-size: 16px;
	font-weight: normal;
	color: #1f7877;
	line-height: 24px;
	margin-top: 10px;
}

#grsy .icon_image {
	width: 24px;
	height: 24px;
	margin-top: 36px;
}

.blackname {
	text-align: left;
	font-size: 18px;
	color: black;
	line-height: 24px;
	margin-top: 26px;
}

.grayname {
	text-align: left;
	font-size: 14px;
	color: gray;
	line-height: 24px;
}

/*修改弹框样式*/
#grsy .el-message-box__header {
	background-color: #eee !important;
	margin: 0 !important;
	padding: 12px !important;
	// 	font-weight: 700;
	font-weight: 400;
}

#grsy .el-message-box {
	border-top: 4px solid #00772e;
}

#grsy .el-message-box__headerbtn .el-message-box__close {
	color: #00772e !important;
}

/*里面的绿色的字*/
.green {
	font-size: 14px;
	color: #ec362b;
	text-align: center;
}

.greens {
	font-size: 12px;
	color: #00772e;
	text-align: right;
}

#grsy .demo-input-suffix {
	color: black;
	font-size: 14px;
	text-align: center;
}

#grsy input {
	width: 264px;
	margin: 10px 0;
	font-size: 14px;
}

#grsy .el-input,
#grsy .el-select {
	width: 264px;
	background-color: #ffffff;
	margin: 8px 0;
	font-size: 14px;
}

#grsy .el-message-box__btns button {
	width: 26% !important;
}

#grsy .el-message-box__btns .el-button {
	color: #00772e !important;
	border-color: #00772e !important;
}

#grsy .el-message-box__btns .el-button--primary {
	background-color: #00772e !important;
	border-color: #00772e !important;
	color: white !important;
}

/*select 选择框*/
#grsy .select {
	background-color: #fff;
	background-image: none;
	border-radius: 0;
	border: 1px solid #000000;
	box-sizing: border-box;
	color: #000;
	display: inline-block;
	font-size: inherit;
	font-weight: bold;
	height: 30px;
	line-height: 1;
	outline: none;
	padding: 0 15px;
	transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
	width: 70%;
}

#grsy .selects {
	background-color: #fff;
	background-image: none;
	border-radius: 0;
	border: 1px solid #999;
	box-sizing: border-box;
	color: #acacac;
	display: inline-block;
	font-size: inherit;
	font-weight: normal;
	height: 30px;
	line-height: 1;
	outline: none;
	padding: 0 15px;
	transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
	width: 70%;
}

#grsy .el-dialog__body {
	padding: 0;
}

#grsy .el-dialog__footer {
	padding: 25px 0 60px;
	text-align: center;
}

#grsy .cancel_btn {
	background-color: #fff;
	color: #0e78c7;
	background-image: none;
	border: 1px solid #0e78c7;
}

.text_style {
	width: 70px;
	display: inline-block;
	text-align: right;
}

#grsy .row_style {
	display: flex;
	align-items: center;
	justify-content: center;
}

#grsy .row_text_style {
	width: 60px;
}

.mid_line {
	height: 80px;
	border-left: 1px solid #e5e6eb;
	position: absolute;
	left: -10%;
	top: 40px;
}

.change_color {
	background: #0e78c7;
}

/* 刷新旋转动画 */
.refresh_anima {
	animation: refresh 1.5s ease-in-out 0s 1 alternate forwards;
}

@keyframes refresh {
	from {
		transform: rotateZ(0deg);
	}
	to {
		transform: rotateZ(360deg);
	}
}

.pas_icon {
	margin-right: 10px;
	margin-left: 0 !important;
	font-size: 26px;
	color: #d86556 !important;
}
.passwordValid {
	padding-left: 150px;
	color: #ec362b;
	font-size: 14px;
	margin-top: 6px;
	margin-bottom: 6px;
	li {
		line-height: 16px;
	}
}
.head__zone {
	width: 100%;
	padding-left: 40px;
	padding-right: 40px;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	align-items: center;
	span {
		margin-left: 10px;
		margin-right: 10px;
		margin-bottom: 15px;
		width: 80px;
		height: 80px;
		cursor: pointer;
		position: relative;
		outline: 3px solid #fff;
		&.check {
			outline: 3px solid rgba(80, 179, 249, 1);
			border-radius: 50%;
		}
		img {
			margin: 0;
			font-size: 0;
			width: 100%;
			-webkit-user-drag: none; /* Safari */
			position: absolute;
			left: 0;
			top: 0;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/UserComps/grsy.vue